const publicData = {
  PublicDataHeader: 'Get data on traffic conditions in Ho Chi Minh City',
  InstructionHeader: 'Follow these steps to get data:',
  InstructionPosition: 'Select a specific location on the map where you want to get the data. The current system offers 3 methods to select the location, please choose one:',
  SpeechChoose: 'Extract from my speech report',
  RectangleChoose: 'Select according to the rectangle',
  LineChoose: 'Select according to the line',
  CircleChoose: 'Select according to the circle',
  InstructionTitle: 'Tutorial:',
  RectangleInstruction: 'Click on the map in turn to select 2 points representing the diagonal of the rectangle, adjust these 2 points to change the size and position of the rectangle.',
  LineInstruction: 'Click on the map in turn to select 2 points representing the beginning and the end of the line, adjust these 2 points to change the position of the line.',
  CircleInstruction: 'Click on the map to select the center point of the circle and adjust the radius with the slider on the map (unit m, minimum value 100m, maximum value 2000m)',
  DateTimePicker: 'Select time when you want to get data:',
  GetDataButton: 'Get data',
  PublicDataResultHeader: 'Result: ',
  PublicDataResult: `Please click on the button "Get data`,
  LabelFromTitle: 'From',
  LabelToTitle: 'To',
  LabelDateSelect: 'Select date',
  LabelTimeSelect: 'Select time',
  ErrorNotChoosePosition: 'Please select a location on the map!',
  ErrorNotChooseTime: 'Please check the time again!', 
  ErrorCoordsNotAvailable: 'Current location is not supported!',
  StartMarker: 'Start point',
  EndMarker: 'End point',
  YouAreHere: 'You are here',
  ErrorTimeFuture: 'Must not choose time in future!',    
  ErrorStartTimeMoreThanEndTime: 'The start time must be less than the end time!',
  ErrorPeriodTime: 'Period time must be less than 6 hours!',
  Distance: 'Distance',
  ChangeModeLabel: 'Change mode:',
  ViewTrafficStatusButton: 'View Traffic Status',
  GetTrafficStatusButton: 'Get Traffic Status',
  ViewTrafficStatusTutorial: `With mode "VIEW TRAFFIC STATUS" you can see traffic status on Map but you can't get data from server.`,
  GetTrafficStatusTutorial: `With mode "GET TRAFFIC STATUS" you can't see traffic status on Map but you can get data from server. Following next steps to get data.`,
  Velocity: 'Velocity:',
  Source: 'Source:',
  ErrorChangeMode: `Please change the mode to "GET TRAFFIC STATUS"`,
}

export default publicData;